import { Component, OnInit, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthUser } from 'src/app/models/auth/AuthUser';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { UsersService } from 'src/app/services/users.service';
import { UserSettingForm } from 'src/app/models/users/UserSettingForm';
import { LanguageList, TimeZoneList, UserSettingDetails } from 'src/app/models/users/UserSettingDetails';
import { DateFormatEnum } from 'src/app/models/users/enums/DateFormat.enum';
import { ThemeEnum } from 'src/app/models/users/enums/Theme.enum';
import { LayoutEnum } from 'src/app/models/users/enums/Layout.enum';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-user-preferences',
  templateUrl: './user-preferences.component.html'
})
export class UserPreferencesComponent implements OnInit {

  formGroup!: FormGroup;
  isSubmitted = false;
  loading = false;
  currentUser = new AuthUser();
  details: UserSettingDetails = new UserSettingDetails();
  dataLoading = false;
  languageList: LanguageList[] = [];
  timeZoneList: TimeZoneList[] = [];
  dateFormatList = [
    { name: 'dd-mm-yyyy', value: DateFormatEnum.A },
    { name: 'mm-dd-yyyy', value: DateFormatEnum.B },
    { name: 'yyyy-mm-dd', value: DateFormatEnum.C }
  ];
  themeList = [
    { name: 'Light', value: ThemeEnum.light },
    { name: 'Dark', value: ThemeEnum.dark }
  ];
  layoutList = [
    { name: 'Tiles', value: LayoutEnum.tiles }
  ];

  constructor(
    private formBuilder: FormBuilder,
    private service: UsersService,
    private auth: AuthenticationService,
    public translate: TranslateService,
    private el: ElementRef,
    private toastr: ToastrService,
    private router: Router
  ) {
    this.currentUser = this.auth.currentUserValue;
  }

  ngOnInit() {
    this.buildForm();
    this.getUserDefinitionForUpdate();
  }

  buildForm() {
    this.formGroup = this.formBuilder.group({
      timeZoneId: ['', Validators.required],
      dateFormat: ['', Validators.required],
      languageId: ['', Validators.required],
      theme: ['', Validators.required],
      layout: ['', Validators.required],
    });
  }

  getUserDefinitionForUpdate() {
    this.dataLoading = true;
    this.service.getUserSetting().subscribe(
      (data: any) => {
        if (data) {
          this.details = data.record as UserSettingDetails;
          this.timeZoneList = data.timeZone as TimeZoneList[];
          this.languageList = data.languages as LanguageList[];
          this.bindDataToUpdate();
          this.dataLoading = false;
        }
      },
      error => {
        this.dataLoading = false;
      });
  }

  bindDataToUpdate() {
    this.formGroup.controls['timeZoneId'].setValue(this.details.timeZoneId);
    this.formGroup.controls['dateFormat'].setValue(this.details.dateFormat);
    this.formGroup.controls['languageId'].setValue(this.details.languageId);
    this.formGroup.controls['theme'].setValue(this.details.theme);
    this.formGroup.controls['layout'].setValue(this.details.layout);
  }

  saveRecord() {
    Swal.fire({
      title: this.translate.instant('swalMsg.are_you_sure'),
      text: 'You will need to re-login. So, the system can apply the requested changes in the date format.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: this.translate.instant('swalMsg.no_keep_it')
    }).then((result) => {
      if (result.value) {
        this.isSubmitted = true;
        if (this.formGroup.valid) {
          this.loading = true;
          const controls = this.formGroup.controls;
          const data = {
            id: this.details.id,
            userId: this.details.userId,
            timeZoneId: controls['timeZoneId'].value,
            dateFormat: controls['dateFormat'].value,
            languageId: controls['languageId'].value,
            theme: controls['theme'].value,
            layout: controls['layout'].value
          } as UserSettingForm;
         // console.log(data);
            this.service.editUserSetting(data).subscribe((res: any) => {
              if (res && res.status) {
                this.loading = false;
                  this.toastr.success('', this.translate.instant('swalMsg.success'), { progressBar: true });
                  this.auth.logout();
              } else {
                  Swal.fire({
                      title: this.translate.instant('swalMsg.failed'),
                      text: this.translate.instant(res.message),
                      icon: 'error',
                      confirmButtonText: this.translate.instant('swalMsg.ok'),
                  });
              }
          }, err => {
           this.loading = false;
         });
        } else {
          this.formGroup.markAllAsTouched();
          this.scrollToFirstInvalidControl();
        }
      }
    });

  }


  hasError(controlName: string, errorName: string) {
    return this.formGroup.controls[controlName].hasError(errorName);
  }

  private scrollToFirstInvalidControl() {
    const firstInvalidControl: HTMLElement = this.el.nativeElement.querySelector(
      'form .ng-invalid'
    );
    firstInvalidControl.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
  }

}
